import { SparklineContainerHeight } from '../types/sparkline-container-height.js';

export const mapContainerHeightToVariant = (
  height: number,
): SparklineContainerHeight => {
  if (height < 32) {
    return SparklineContainerHeight.HEIGHT24;
  }
  return SparklineContainerHeight.HEIGHT32;
};
